export default "__VITE_ASSET__3ThkS49a__"